<template>
  <div class="bgf4">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <div class="search">
        <input type="text" class="searchInput" placeholder="请输入姓名进行搜索" v-model="name" @keyup.enter="queryname">
        <button @click="queryname">搜索</button>
      </div>
      <div style="margin-top:5px;">
        <a-row :gutter="16"  >
        <a-col :span="3.5" v-for="item in data" :key="item.id" >
          <div  :bordered="false" class="card" @click="zjdetial(item.id)">
            <div class="tzlist">
              <div>
                <img v-if="item.expertimage!=null" :src="'http://bz.sdscxh.cn/jeecg-boot/sys/common/static/'+item.expertimage" style="width:68px;height:96px">
                <img v-else src="../../images/expert1.png" style="width:68px;height:96px">
              </div>
              <br/>
              <p class="zjname">{{item.expertname}}</p>
              <p style="font-weight:bold">{{item.profession}}</p>
            </div>
            <!--<div class="bzlist">山东水产协会</div>-->
          </div>
        </a-col>
        </a-row>
      </div>
      <div class="fy" v-if="data.length>0">
        <span style="margin-top:4px;margin-right:5px">共&nbsp;{{total}}&nbsp;条记录</span>
        <div class="fir"><a @click="btnfir" :disabled="disabled" ref="fa">首页</a></div>
        <a-config-provider :locale="locale">
        <a-pagination  :total="ipagination.total" :item-render="itemRender" :pagination="ipagination" :defaultPageSize="ipagination.pageSize"
        v-model="ipagination.pageNo" @change='changePage'>
        </a-pagination>
        </a-config-provider>
        <div class="end"><a ref="end" :disabled="disablede" @click="endbtn">末页</a></div>
        <span style="margin-left:5px" v-if="tjcx==1">跳至&nbsp;<a-input type="text" v-model="text" @blur="change" style="width:50px;border:normal" />&nbsp;页</span>
      </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'App',
  data(){
    return{
      data:[],
      disabled:false,
      disablede:false,
      locale: zhCN,
      ipagination:{
        current: 1,
        pageNo:1,
        pageSize: 24,
        pageSizeOptions: ['24', '30', '36'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      name:'',
      total:0,
      text:null,
      tjcx:1
    }
  },
  computed:{

  },
  created(){
    this.query()
    if(this.ipagination.total=='0'){
      this.disablede = true
      this.disabled = true
    }
  },
  mounted () {

  },
  watch: {
    ipagination: {
        handler(newVal) {
            setTimeout(() => {
              if(newVal.pageNo=='1'){
              this.disabled = true
              this.$refs.fa.style.color = '#bfbfbf'
              }else{
                this.disabled = false
                this.$refs.fa.style.color = '#595959'
              }


            let end = newVal.total/newVal.pageSize
            end = Math.ceil(end)
            if(newVal.current!=end){
              this.disablede = false
              this.$refs.end.style.color = '#595959'
            }else{
              this.$refs.end.style.color = '#bfbfbf'
              this.disablede = true
            }
            }, 50);
        },
        deep: true
    }
  },
  methods: {
    change(e){
      var i = parseInt(e.target.value)
      let end = this.total/this.ipagination.pageSize
      end = Math.ceil(end)
      if(i>end){
        this.ipagination.current = end
        this.ipagination.pageNo = end
        this.text = null
      }else if(i==0){
        this.ipagination.current = 1
        this.ipagination.pageNo = 1
        this.text = null
      }else if(e.target.value==null || e.target.value==''){

      }
      else{
        this.ipagination.current = i
        this.ipagination.pageNo = i
        this.text = i
      }
      this.query()

    },
    zjdetial(id){
      window.open('aquaticexpertsdetial?id='+id)
    },
    changeText(e){
      this.name = e.target.value
    },
    query(){
      http.get('/queryAllZjk',{params:{pageNo:this.ipagination.pageNo,pageSize:this.ipagination.pageSize}}
      ).then((res) => {
          this.data = res.data.result.records
          this.ipagination.total = res.data.result.total
          this.ipagination.current = res.data.result.current
          this.total = res.data.result.total
      })
    },
    queryname(){
      if(this.text!=null){
        this.text=null
      }
      if(this.name==null || this.name==''){
        this.tjcx=1
      }else{
        this.tjcx = 2
      }
      this.ipagination.pageNo = 1
      http.get('/queryAllZjk',{params:{pageNo:this.ipagination.pageNo,pageSize:this.ipagination.pageSize,name:this.name}}
      ).then((res) => {
          this.data = res.data.result.records
          this.ipagination.total = res.data.result.total
          this.ipagination.current = res.data.result.current
          this.total = res.data.result.total
      })
    },
    endbtn(){
      if(this.text!=null){
        this.text=null
      }
      let end = this.ipagination.total/this.ipagination.pageSize
      end = Math.ceil(end)
      this.ipagination.pageNo = end
      this.query()
    },
    btnfir(){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = 1
      this.query()
    },
    changePage(e){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = e
      this.query()
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <div class="pre"><a>上一页</a></div>;
      } else if (type === 'next') {
        return <div class="next"><a>下一页</a></div>;
      }
      return originalElement;
    },
  },
}
</script>


<style scoped>
  @import "../../config/AquaticExperts.css"
</style>







// WEBPACK FOOTER //
// src/views/aquaticexperts/AquaticExperts.vue